import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants/index';

const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: flex-start;
    background-color: white;
    padding: 0px 0px 0px 0px;
    /* margin-top: 30px; */
    border-radius: 3px;
    /* max-width: ${constants.layout.contentWidth.maxWidth - 20}px; */
    /* max-width: 95%; */
    /* align-self: center; */
    box-shadow: -3px -1px 40px 0px rgba(0,0,0,0.16);
    /* max-width: 500px; */
    flex: 1;
    border-radius: 20px 20px 20px 20px;
    overflow: hidden;
    margin-bottom: 25px;
`;

const ServiceCardListOuterContainer = ({ styles, onClick, children, ...rest }) => (
    <StyledDiv style = {styles} className="ServiceCardListOuterContainer"  onClick = {onClick} {...rest} >
        { children }
    </StyledDiv>
)

export default ServiceCardListOuterContainer


// WEBPACK FOOTER //
// ./src/js/components/ServiceCardList/ServiceCardListOuterContainer.jsx